
import apiWorker from '../apiWorker'

const leads =  {
    create : (data) => apiWorker('post', `/v1/marketing/leads`, data, true),
}

export default leads;